import {
  getCollectionUrlFieldOptions,
  setPathAndSeoFieldOptionsAccrodingToHrefFrom,
} from './utils';
import { loadPageTraitOptions } from '../commonTraitsMethod/pageTraits';
import { getCollectionOptionsForSelect } from '../pluginComponentApi';
import { convertUtilityToOptions } from '../dataGroup/traitsApi';

export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { projectId, pageCollection, collections, version } = opt;
  console.log('version hrefTrait ', version);
  const utilities = collections.flatMap((collection) => collection.utilities);
  const urlParamUtilities = utilities.filter(
    (utility) => utility.functionType === 'URL_PARAMETERS',
  );
  const utilityOptions = convertUtilityToOptions(urlParamUtilities);
  const traitOpts = await loadPageTraitOptions(projectId, version);
  const { session } = opt.bindCollectionOptions;
  const style = document.createElement('style');
  style.innerHTML = `
  .webconnect-link__url__newtab~.checkmark::after {
    position: relative;
    left: -13px;
    top: -3px;
  }

  .webconnect-link__page__newtab~.checkmark::after {
    position: relative;
    left: -13px;
    top: -3px;
  }

  .webconnect-link__url__newwindow~.checkmark::after {
    position: relative;
    left: -13px;
    top: -3px;
  }

  .webconnect-link__page__newwindow~.checkmark::after {
    position: relative;
    left: -13px;
    top: -3px;
  }

  .webconnect-link__page__displayUrl~.checkmark::after {
    position: relative;
    left: -13px;
    top: -3px;
  }

  input:checked~.checkmark {
    background-color: transparent;
  }
  `;
  document.head.appendChild(style);
  traitManager.addType(opt.traits.type, {
    createInput({ trait }) {
      const component = editor.getSelected();
      const tdComponent =
        component && typeof component.closest === 'function' ? component.closest('td') : null;
      const hasActionSelectedColumn =
        tdComponent && tdComponent.getAttributes()['data-selected-column'] === 'action';

      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `<div class="gjs-tab">
      <button class="gjs-tablinks active webconnect-link__ext" title="URL">
        <i class="webconnect-link-solid"></i>
      </button>
      <button class="gjs-tablinks webconnect-link__page" title="Page">
        <i class="webconnect-file-alt"></i>
      </button>
      <button class="gjs-tablinks webconnect-link__mail" title="Email">
        <i class="webconnect-pencil"></i>
      </button>
      <button class="gjs-tablinks webconnect-link__add" title="Phone">
        <i class="webconnect-address-card"></i>
      </button>
    </div>
    
    <div id="URL" class="gjs-tabcontent" style="display: block;">
      <div class="gjs-container">
        <div id="getUrlDiv" class="gjs-row">
          <div class="gjs-label-wrp"><div class="gjs-label" title="Get URL">Get URL</div></div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__url">
            <select class="select-getUrl form-control form-control-sm options-light">
              <option value="" selected>- Get URL -</option>
              <option value="collectionField">Collection (Data Group/Table)</option>
              <option value="static"> Static Value </option>
            </select>
          </div>
        </div>
        <div id="collectionFieldDiv" class="gjs-row" style="display: none !important;" >
          <div class="gjs-label-wrp"><div class="gjs-label" title="URL">URL</div></div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__url">
            <select class="select-collectionField form-control form-control-sm options-light">
              <option value="" selected>- None -</option>
            </select>
          </div>
        </div>
        ${
          hasActionSelectedColumn
            ? `
        <div class="gjs-row">
          <div class="gjs-label-wrp">
            <div class="gjs-label" title="Display URL">Display URL</div>
          </div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__page__displayUrl">
            <input type="checkbox" class="gjs-field webconnect-link__page__displayUrl" name="displayUrl" />
            <span class="checkmark"></span>
          </div>
      </div>
        `
            : ''
        }
        <div id="staticValueDiv" class="gjs-row" style="display: none !important;" >
          <div class="gjs-label-wrp"><div class="gjs-label" title="URL">URL</div></div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__url">
            <input type="text" class="gjs-field webconnect-link__url" placeholder="ex: www.google.co.in" />
          </div>
        </div>
        <div class="gjs-row">
          <div class="gjs-label-wrp">
            <div class="gjs-label" title="Open in new tab">Open in new tab</div>
          </div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__url__newtab">
          <input type="checkbox" class="gjs-field webconnect-link__url__newtab" name="newtab" />
          <span class="checkmark"></span>
        </div>
        </div>
          <div class="gjs-row">
          <div class="gjs-label-wrp">
            <div class="gjs-label" title="Open in new window">Open in new window</div>
            <small>(this takes priority over tab)</small>
          </div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__url__newwindow">
            <input type="checkbox" class="gjs-field webconnect-link__url__newwindow" name="newwindow" />
            <span class="checkmark"></span>
          </div>
        </div>
      </div>
    </div>
    <div id="PAGE" class="gjs-tabcontent">
    <div class="gjs-container">  
      <div class="gjs-row">
        <div class="gjs-label-wrp">
          <div class="gjs-label" title="Page">Page</div>
        </div>
        <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__type">
          <div class="gjs-field">
            <select class="webconnect-link__type">
            ${traitOpts
              .map(
                (opt) =>
                  `<option value="${opt.id}" data-collectionId="${opt.collectionId}">${opt.name}</option>`,
              )
              .join('')}
            </select>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp">
          <div class="gjs-label" title="Page">Get Path Link ID</div>
        </div>
        <div id="select-getHrefCollectionIdFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getHrefCollectionIdFrom">
          <div class="gjs-field">
          <select class="select-getHrefCollectionIdFrom form-control form-control-sm options-light">
            <option value="" selected>- Get Path Field  -</option>
            ${session ? `<option value="session">Logged In User</option>` : ''} 
            <option value="parentCollection">Collection (Data Group/Table)</option>
            <option value="browserStorage">Collection (Browser Storage)</option>
            ${pageCollection ? `<option value="pageCollection">Page Collection</option>` : ''}
          </select>
          </div>
        </div>
      </div>    
      <div class="gjs-row webconnect-link__browserStorageKeyDiv" style="display: none !important;" >
        <div class="gjs-label-wrp">
          <div class="gjs-label" title="Collection Name">Collection Name</div>
        </div>
        <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__browserStorageKey">
          <div class="gjs-field">
            <select class="webconnect-link__browserStorageKey"></select>
          </div>
        </div>
      </div>
      <div class="gjs-row webconnect-link__pathFieldDiv">
        <div class="gjs-label-wrp">
          <div class="gjs-label" title="Path Field">Path Field</div>
        </div>
        <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__pathField">
          <div class="gjs-field">
            <select class="webconnect-link__pathField">
            </select>
          </div>
        </div>
      </div>
      <div class="gjs-row webconnect-link__pathSEODiv">
        <div class="gjs-label-wrp">
          <div class="gjs-label" title="SEO Field">SEO Field</div>
        </div>
        <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__pathSEO">
          <div class="gjs-field">
            <select class="webconnect-link__pathSEO">
            
            </select>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp">
          <div class="gjs-label" title="Open in new tab">Open in new tab</div>
        </div>
        <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__page__newtab">
          <input type="checkbox" class="gjs-field webconnect-link__page__newtab" name="newtab"/>
          <span class="checkmark"></span>
        </div>
      </div>
      <div class="gjs-row">
          <div class="gjs-label-wrp">
            <div class="gjs-label" title="Open in new window">Open in new window</div>
            <small>(this takes priority over tab)</small>
          </div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__page__newwindow">
            <input type="checkbox" class="gjs-field webconnect-link__page__newwindow" name="newwindow" />
            <span class="checkmark"></span>
          </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp">
          <div class="gjs-label" title="Param">Param</div>
        </div>
        <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__params">
          <input type="text" class="gjs-field webconnect-link__params" placeholder="name=vijay&page=20"/>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp">
          <div class="gjs-label" title="Dynamic Param">Dynamic Params</div>
        </div>
        <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__params">
        <select class="select-getHrefCollectionIdFrom form-control form-control-sm options-light">
        <option value="" selected>- Select Param  -</option>
        ${utilityOptions
          .map((urlParam) => `<option value=${urlParam.id}>${urlParam.name}</option>`)
          .join('')}
      </select>
        </div>
      </div>
    </div>
    </div>
    <div id="EMAIL" class="gjs-tabcontent">
      <div class="gjs-container">
        <div class="gjs-row">
          <div class="gjs-label-wrp"><div class="gjs-label" title="Email">Email</div></div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__email">
            <input type="email" class="gjs-field webconnect-link__email" placeholder="Email"/>
          </div>
        </div>
        <div class="gjs-row">
          <div class="gjs-label-wrp"><div class="gjs-label" title="Subject">Subject</div></div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__subject">
            <input type="email" class="gjs-field webconnect-link__subject" placeholder="Subject"/>
          </div>
        </div>
      </div>
    </div>
    <div id="PHONE" class="gjs-tabcontent">
      <div class="gjs-container">
        <div class="gjs-row">
          <div class="gjs-label-wrp"><div class="gjs-label" title="Phone">Phone</div></div>
          <div class="gjs-field-wrp gjs-field-wrp--webconnect-link__phone">
            <input type="text" class="gjs-field webconnect-link__phone" placeholder="+1 0000000000"/>
          </div>
        </div>
      </div>
    </div>
    `;

      const inputsPhone = el.querySelector('.webconnect-link__phone');
      const inputsSubject = el.querySelector('.webconnect-link__subject');
      const inputsEmail = el.querySelector('.webconnect-link__email');
      const inputsParams = el.querySelector('.webconnect-link__params');
      const inputsUrlNewTab = el.querySelector('.webconnect-link__url__newtab');
      const inputsPageNewTab = el.querySelector('.webconnect-link__page__newtab');
      const inputsUrlNewWindow = el.querySelector('.webconnect-link__url__newwindow');
      const inputsPageNewWindow = el.querySelector('.webconnect-link__page__newwindow');
      const inputsUrl = el.querySelector('.webconnect-link__url');
      const inputsType = el.querySelector('.webconnect-link__type');
      const inputsPathName = el.querySelector('.webconnect-link__pathField');
      const inputsPathSEO = el.querySelector('.webconnect-link__pathSEO');
      const getHrefCollectionIdFrom = el.querySelector('.select-getHrefCollectionIdFrom');
      const inputsDisplayUrl = el.querySelector('.webconnect-link__page__displayUrl');

      //Button Inputs and tab input
      const urlButton = el.querySelector('.webconnect-link__ext');
      const urlTab = el.querySelector('#URL');
      const getUrlDiv = el.querySelector('#getUrlDiv');
      const selectGetUrl = el.querySelector('.select-getUrl');
      const collectionFieldDiv = el.querySelector('#collectionFieldDiv');
      const staticValueDiv = el.querySelector('#staticValueDiv');
      const selectCollectionField = el.querySelector('.select-collectionField');

      const pageButton = el.querySelector('.webconnect-link__page');
      const pageTab = el.querySelector('#PAGE');

      const emailButton = el.querySelector('.webconnect-link__mail');
      const emailTab = el.querySelector('#EMAIL');

      const phoneButton = el.querySelector('.webconnect-link__add');
      const pathNameSelectDiv = el.querySelector('.webconnect-link__pathFieldDiv');
      const phoneTab = el.querySelector('#PHONE');
      const browserStorageKeyDiv = el.querySelector('.webconnect-link__browserStorageKeyDiv');
      const browserStorageKey = el.querySelector('.webconnect-link__browserStorageKey');

      urlButton.addEventListener('click', (ev) => {
        ev.currentTarget.className += ' active';
        pageButton.classList.remove('active');
        emailButton.classList.remove('active');
        phoneButton.classList.remove('active');

        urlTab.style.display = 'block';
        getUrlDiv.style.setProperty('display', 'flex', 'important');
        collectionFieldDiv.style.setProperty('display', 'none', 'important');
        staticValueDiv.style.setProperty('display', 'none', 'important');
        pageTab.style.display = 'none';
        emailTab.style.display = 'none';
        phoneTab.style.display = 'none';
        pathNameSelectDiv.style.display = 'none';
        browserStorageKeyDiv.style.display = 'none';

        inputsPhone.value = '';
        inputsSubject.value = '';
        inputsEmail.value = '';
        inputsType.value = '';
        inputsUrlNewTab.checked = false;
        inputsPageNewTab.checked = false;
        inputsUrlNewWindow.checked == false;
        inputsPageNewWindow.checked == false;
        if (inputsDisplayUrl) inputsDisplayUrl.checked = false;
        getHrefCollectionIdFrom.value = '';
        inputsPathName.value = '';
        inputsPathSEO.value = '';
      });

      pageButton.addEventListener('click', (ev) => {
        ev.currentTarget.className += ' active';
        urlButton.classList.remove('active');
        emailButton.classList.remove('active');
        phoneButton.classList.remove('active');

        urlTab.style.display = 'none';
        pageTab.style.display = 'block';
        emailTab.style.display = 'none';
        phoneTab.style.display = 'none';
        pathNameSelectDiv.style.display = 'block';
        browserStorageKeyDiv.style.display = 'none';

        inputsUrl.value = '';
        inputsPhone.value = '';
        inputsSubject.value = '';
        inputsEmail.value = '';
        inputsUrlNewTab.checked = false;
        inputsPageNewTab.checked = false;
        inputsUrlNewWindow.checked == false;
        inputsPageNewWindow.checked == false;
        if (inputsDisplayUrl) inputsDisplayUrl.checked = false;
      });

      emailButton.addEventListener('click', (ev) => {
        ev.currentTarget.className += ' active';
        urlButton.classList.remove('active');
        pageButton.classList.remove('active');
        phoneButton.classList.remove('active');

        urlTab.style.display = 'none';
        pageTab.style.display = 'none';
        emailTab.style.display = 'block';
        phoneTab.style.display = 'none';
        pathNameSelectDiv.style.display = 'none';
        browserStorageKeyDiv.style.display = 'none';

        inputsUrl.value = '';
        inputsPhone.value = '';
        inputsParams.value = '';
        inputsType.value = '';
        inputsUrlNewTab.checked = '';
        inputsPageNewTab.checked = '';
        inputsUrlNewWindow.checked == '';
        inputsPageNewWindow.checked == '';
        if (inputsDisplayUrl) inputsDisplayUrl.checked = false;
        getHrefCollectionIdFrom.value = '';
        inputsPathName.value = '';
        inputsPathSEO.value = '';
      });

      phoneButton.addEventListener('click', (ev) => {
        ev.currentTarget.className += ' active';
        urlButton.classList.remove('active');
        pageButton.classList.remove('active');
        emailButton.classList.remove('active');

        urlTab.style.display = 'none';
        pageTab.style.display = 'none';
        emailTab.style.display = 'none';
        phoneTab.style.display = 'block';
        pathNameSelectDiv.style.display = 'none';
        browserStorageKeyDiv.style.display = 'none';

        inputsUrl.value = '';
        inputsSubject.value = '';
        inputsEmail.value = '';
        inputsParams.value = '';
        inputsType.value = '';
        inputsUrlNewTab.checked = false;
        inputsPageNewTab.checked = false;
        inputsUrlNewWindow.checked == false;
        inputsPageNewWindow.checked == false;
        if (inputsDisplayUrl) inputsDisplayUrl.checked = false;
        getHrefCollectionIdFrom.value = '';
        inputsPathName.value = '';
        inputsPathSEO.value = '';
      });

      getHrefCollectionIdFrom.addEventListener('change', (ev) => {
        if (ev.target.value === 'browserStorage') {
          browserStorageKeyDiv.style.setProperty('display', 'flex', 'important');
          browserStorageKey.innerHTML = collections
            ? getCollectionOptionsForSelect(collections)
            : '';
        } else {
          browserStorageKeyDiv.style.setProperty('display', 'none', 'important');
        }
      });

      selectGetUrl.addEventListener('change', async (ev) => {
        if (ev.target.value === 'collectionField') {
          collectionFieldDiv.style.setProperty('display', 'block');
          collectionFieldDiv.classList.add('gjs-row');
          staticValueDiv.style.setProperty('display', 'none', 'important');
          const collectionUrlSelectOptions = await getCollectionUrlFieldOptions(
            projectId,
            version,
            editor.getSelected(),
            collections,
          );
          selectCollectionField.innerHTML = collectionUrlSelectOptions;
        } else if (ev.target.value === 'static') {
          staticValueDiv.style.setProperty('display', 'block');
          staticValueDiv.classList.add('gjs-row');
          collectionFieldDiv.style.setProperty('display', 'none', 'important');
        }
      });

      return el;
    },
    async onEvent({ elInput, component, event }) {
      const inputsUrl = elInput.querySelector('.webconnect-link__url');
      const inputUrlValue = inputsUrl.value;
      const selectGetUrl = elInput.querySelector('.select-getUrl');
      const selectCollectionField = elInput.querySelector('.select-collectionField');
      const selectGetUrlValue = selectGetUrl.value || '';
      const selectCollectionFieldValue = selectCollectionField.value || '';
      const inputsParams = elInput.querySelector('.webconnect-link__params');
      const inputParamsValue = inputsParams.value;
      const inputsDisplayUrl = elInput.querySelector('.webconnect-link__page__displayUrl');
      const inputDisplayUrlValue = inputsDisplayUrl ? inputsDisplayUrl.checked : false;

      const inputsEmail = elInput.querySelector('.webconnect-link__email');
      const inputEmailValue = inputsEmail.value;

      const inputsSubject = elInput.querySelector('.webconnect-link__subject');
      const inputSubjectValue = inputsSubject.value;

      const inputsPhone = elInput.querySelector('.webconnect-link__phone');
      const inputPhoneValue = inputsPhone.value;

      const inputsPages = elInput.querySelector('.webconnect-link__type');
      const inputPagesValue = inputsPages.value;
      var selected = inputsPages.options[inputsPages.selectedIndex];
      const selectedPageCollection = selected.getAttribute('data-collectionid');
      const browserStorageKey = elInput.querySelector('.webconnect-link__browserStorageKey');
      const browserStorageKeyValue = browserStorageKey.value;

      let href = '';
      let target = '';
      let pageSlug = '';
      let attrs = component.getAttributes();

      if (inputPhoneValue || inputUrlValue || selectGetUrlValue || inputEmailValue) {
        if (inputPhoneValue) {
          href = `tel:${inputPhoneValue}`;
        }
        if (inputEmailValue) {
          href = `mailto:${inputEmailValue}${
            inputSubjectValue ? `?subject=${inputSubjectValue}` : ''
          }`;
        }
        if (inputUrlValue || selectGetUrlValue) {
          if (selectGetUrlValue === 'collectionField') {
            const selectCollectionFieldValueOption =
              selectCollectionField.options[selectCollectionField.selectedIndex];
            const collectionName = selectCollectionFieldValueOption
              ? selectCollectionFieldValueOption.getAttribute('data-collectionid')
              : '';
            href = selectCollectionFieldValue;
            attrs['data-url-field'] = selectCollectionFieldValue;
            attrs['data-url-collection'] = collectionName;
          } else if (selectGetUrlValue === 'static') {
            href = inputUrlValue;
            delete attrs['data-url-field'];
            delete attrs['data-url-collection'];
          }
          attrs['data-url-from'] = selectGetUrlValue;
          if (inputsDisplayUrl) {
            attrs['displayUrl'] = inputDisplayUrlValue ? 'true' : 'false';
          } else {
            delete attrs['displayUrl'];
          }
          const checkboxResult = handleNewTabAndWindowCheckbox(elInput, event, attrs, target);
          attrs = checkboxResult.attrs;
          target = checkboxResult.target;
        } else {
          delete attrs['displayUrl'];
        }
        //these are page tab attribute to delete on change
        delete attrs['data-page-slug'];
        delete attrs['data-selected-page-collection'];
        delete attrs['data-path-collection-item-id-from'];
        delete attrs['data-session'];
        delete attrs['data-path-collection-name'];
        delete attrs['data-path-field-name'];
        delete attrs['data-path-field-seo'];
        attrs['href'] = href;
        attrs['target'] = target;
      } else if (inputPagesValue) {
        pageSlug = inputPagesValue;

        const selectGetHrefCollectionItemIdFrom = elInput.querySelector(
          '.select-getHrefCollectionIdFrom',
        );
        const inputPathField = elInput.querySelector('.webconnect-link__pathField');
        const inputPathSEO = elInput.querySelector('.webconnect-link__pathSEO');
        const selectGetHrefCollectionItemIdFromValue = selectGetHrefCollectionItemIdFrom.value;
        const dataStorageKey = attrs['data-storage-key'] ? attrs['data-storage-key'] : '';
        const condition =
          selectGetHrefCollectionItemIdFromValue !== attrs['data-path-collection-item-id-from'] ||
          browserStorageKeyValue !== dataStorageKey.replace('entity_', '');
        if (condition) {
          await setPathAndSeoFieldOptionsAccrodingToHrefFrom(
            component,
            inputPathField,
            inputPathSEO,
            projectId,
            version,
            pageCollection,
            session,
            selectGetHrefCollectionItemIdFromValue,
            collections,
            browserStorageKeyValue,
          );
        }

        const pathFieldValue = inputPathField.value;
        const pathSEOValue = inputPathSEO.value;
        const inputPathFieldOption = inputPathField.options[inputPathField.selectedIndex];
        const pathCollectionName = inputPathFieldOption
          ? inputPathFieldOption.getAttribute('data-collectionid')
          : '';

        if (
          selectGetHrefCollectionItemIdFromValue &&
          pathCollectionName &&
          pathCollectionName !== 'undefined' &&
          pathFieldValue &&
          pathFieldValue !== 'undefined'
        ) {
          if (pathSEOValue && pathSEOValue !== 'undefined') {
            href = `${pageSlug}/${pathCollectionName}/${pathSEOValue}_${pathFieldValue}`;
          } else {
            href = `${pageSlug}/${pathCollectionName}/${pathFieldValue}`;
          }
          attrs = {
            ...attrs,
            'data-path-collection-item-id-from': selectGetHrefCollectionItemIdFromValue,
            'data-path-collection-name': pathCollectionName,
            'data-path-field-name': pathFieldValue,
            'data-path-field-seo': pathSEOValue,
            'data-page-slug': pageSlug,
          };

          if (selectGetHrefCollectionItemIdFromValue === 'session') {
            attrs = { ...attrs, 'data-session': pathFieldValue };
          }
        } else {
          delete attrs['data-session'];
          delete attrs['data-path-collection-name'];
          delete attrs['data-path-field-name'];
          delete attrs['data-path-field-seo'];
          delete attrs['data-storage-key'];
        }
        attrs['data-page-slug'] = pageSlug;
        attrs['data-selected-page-collection'] =
          selectedPageCollection && selectedPageCollection !== 'undefined'
            ? selectedPageCollection
            : '';
        if (browserStorageKeyValue) attrs['data-storage-key'] = `entity_${browserStorageKeyValue}`;
        attrs['data-path-collection-item-id-from'] = selectGetHrefCollectionItemIdFromValue;
        attrs['href'] = href ? href : pageSlug;
        if (inputParamsValue) attrs['href'] += `?${inputParamsValue}`;
        const checkboxResult = handleNewTabAndWindowCheckbox(elInput, event, attrs, target);
        attrs = checkboxResult.attrs;
        target = checkboxResult.target;
        attrs['target'] = target;
        delete attrs['displayUrl'];
      } else {
        attrs['href'] = '';
        delete attrs['data-page-slug'];
        delete attrs['data-selected-page-collection'];
        delete attrs['data-path-collection-name'];
        delete attrs['data-path-collection-item-id-from'];
        delete attrs['data-session'];
        delete attrs['data-path-field-name'];
        delete attrs['data-path-field-seo'];
        delete attrs['data-url-field'];
        delete attrs['data-url-collection'];
        delete attrs['displayUrl'];
      }
      const cmsComponent = component.closestType('data-table');
      if (cmsComponent) {
        attrs['data-gjs'] = 'data-table-link';
      }
      component.setAttributes(attrs);
    },
    async onUpdate({ elInput, component, event }) {
      const inputsUrl = elInput.querySelector('.webconnect-link__url');
      const selectGetUrl = elInput.querySelector('.select-getUrl');
      const selectCollectionField = elInput.querySelector('.select-collectionField');
      const collectionFieldDiv = elInput.querySelector('#collectionFieldDiv');
      const staticValueDiv = elInput.querySelector('#staticValueDiv');
      const inputsDisplayUrl = elInput.querySelector('.webconnect-link__page__displayUrl');
      if (inputsDisplayUrl) inputsDisplayUrl.checked = false;

      const urlButton = elInput.querySelector('.webconnect-link__ext');
      const urlTab = elInput.querySelector('#URL');

      const pageButton = elInput.querySelector('.webconnect-link__page');
      const pageTab = elInput.querySelector('#PAGE');

      const emailButton = elInput.querySelector('.webconnect-link__mail');
      const emailTab = elInput.querySelector('#EMAIL');

      const phoneButton = elInput.querySelector('.webconnect-link__add');
      const phoneTab = elInput.querySelector('#PHONE');

      const inputsUrlNewTab = elInput.querySelector('.webconnect-link__url__newtab');
      const inputsPageNewTab = elInput.querySelector('.webconnect-link__page__newtab');

      const inputsUrlNewWindow = elInput.querySelector('.webconnect-link__url__newwindow');
      const inputsPageNewWindow = elInput.querySelector('.webconnect-link__page__newwindow');

      const inputsParams = elInput.querySelector('.webconnect-link__params');
      const inputsEmail = elInput.querySelector('.webconnect-link__email');
      const inputsSubject = elInput.querySelector('.webconnect-link__subject');
      const inputsPhone = elInput.querySelector('.webconnect-link__phone');
      const inputsPages = elInput.querySelector('.webconnect-link__type');
      const selectedPage = inputsPages.options[inputsPages.selectedIndex];
      const selectedPageCollection = selectedPage.getAttribute('data-collectionid');

      const inputPathField = elInput.querySelector('.webconnect-link__pathField');
      const inputPathSEO = elInput.querySelector('.webconnect-link__pathSEO');
      const inputPathDiv = elInput.querySelector('.webconnect-link__pathFieldDiv');
      const selectGetHrefCollectionItemIdFrom = elInput.querySelector(
        '.select-getHrefCollectionIdFrom',
      );
      const browserStorageKeyDiv = elInput.querySelector('.webconnect-link__browserStorageKeyDiv');
      const browserStorageKey = elInput.querySelector('.webconnect-link__browserStorageKey');

      const href = component.getAttributes().href || '';
      const onClick = component.getAttributes().onclick || '';
      const target = component.getAttributes().target || '';
      const pathCollectionName = component.getAttributes()['data-path-collection-name'] || '';
      const selectGetHrefCollectionItemIdFromValue =
        component.getAttributes()['data-path-collection-item-id-from'] || '';
      const pathFieldName = component.getAttributes()['data-path-field-name'] || '';
      const pathSEOName = component.getAttributes()['data-path-field-seo'] || '';
      const pageSlug = component.getAttributes()['data-page-slug'] || '';
      const dataStorageKey = component.getAttributes()['data-storage-key'] || '';
      const browserStorageKeyValue = dataStorageKey.replace('entity_', '');

      const dataUrlFrom = component.getAttributes()['data-url-from'] || '';
      const dataUrlField = component.getAttributes()['data-url-field'] || '';
      if (selectGetHrefCollectionItemIdFromValue === 'browserStorage' && dataStorageKey) {
        browserStorageKey.innerHTML = collections ? getCollectionOptionsForSelect(collections) : '';
        browserStorageKey.value = browserStorageKeyValue;
        browserStorageKeyDiv.style.setProperty('display', 'flex', 'important');
      } else {
        browserStorageKeyDiv.style.setProperty('display', 'none', 'important');
      }
      if (href === undefined || href === 'undefined') {
        console.log('Href is undefined');
      } else if (href.indexOf('mailto:') === 0) {
        const mailTo = href.replace('mailto:', '').split('?');
        const email = mailTo[0];
        const params = (mailTo[1] || '').split('&').reduce((acc, item) => {
          const items = item.split('=');
          acc[items[0]] = items[1];
          return acc;
        }, {});

        inputsEmail.value = email || '';
        inputsSubject.value = params.subject || '';
        emailTab.style.display = 'block';
        emailButton.classList.add('active');

        urlButton.classList.remove('active');
        pageButton.classList.remove('active');
        phoneButton.classList.remove('active');

        urlTab.style.display = 'none';
        pageTab.style.display = 'none';
        phoneTab.style.display = 'none';
      } else if (href.indexOf('tel:') === 0) {
        const phoneNo = href.replace('tel:', '');
        inputsPhone.value = phoneNo;
        phoneTab.style.display = 'block';
        phoneButton.classList.add('active');

        urlButton.classList.remove('active');
        pageButton.classList.remove('active');
        emailButton.classList.remove('active');

        urlTab.style.display = 'none';
        pageTab.style.display = 'none';
        emailTab.style.display = 'none';
      } else if (href.includes('http://') || href.includes('https://') || dataUrlFrom) {
        if (target === '_blank') {
          inputsUrlNewTab.checked = true;
        }
        if (onClick === `return openLinkInNewWindow(this)`) {
          inputsUrlNewWindow.checked = true;
        }
        if (inputsDisplayUrl)
          inputsDisplayUrl.checked = component.getAttributes().displayUrl === 'true';
        selectGetUrl.value = dataUrlFrom;
        if (dataUrlFrom === 'collectionField') {
          const collectionUrlSelectOptions = await getCollectionUrlFieldOptions(
            projectId,
            version,
            component,
            collections,
          );
          selectCollectionField.innerHTML = collectionUrlSelectOptions;
          selectCollectionField.value = dataUrlField;
          collectionFieldDiv.style.setProperty('display', 'block');
          collectionFieldDiv.classList.add('gjs-row');
          staticValueDiv.style.setProperty('display', 'none', 'important');
        } else if (dataUrlFrom === 'static') {
          inputsUrl.value = href;
          staticValueDiv.style.setProperty('display', 'block');
          staticValueDiv.classList.add('gjs-row');
          collectionFieldDiv.style.setProperty('display', 'none', 'important');
        }
        urlTab.style.display = 'block';
        urlButton.classList.add('active');

        phoneButton.classList.remove('active');
        pageButton.classList.remove('active');
        emailButton.classList.remove('active');

        phoneTab.style.display = 'none';
        pageTab.style.display = 'none';
        emailTab.style.display = 'none';
      } else if (href === '#' && onClick) {
        urlButton.classList.remove('active');
        pageButton.classList.remove('active');
        emailButton.classList.remove('active');
        phoneButton.classList.remove('active');

        urlTab.style.display = 'none';
        pageTab.style.display = 'none';
        emailTab.style.display = 'none';
        phoneTab.style.display = 'none';
      } else {
        //Logic to populate value
        const urlParms = href.split('?');
        inputsParams.value = urlParms[1] || '';
        inputsPages.value = pageSlug || '';

        let selectedOption = inputsPages.querySelector('option[value="' + href + '"]');
        if (selectedOption) {
          selectedOption.selected = 'selected';
        }

        if (!inputPathField.options.length) {
          await setPathAndSeoFieldOptionsAccrodingToHrefFrom(
            component,
            inputPathField,
            inputPathSEO,
            projectId,
            version,
            pageCollection,
            session,
            selectGetHrefCollectionItemIdFromValue,
            collections,
            browserStorageKeyValue,
          );
        }

        selectGetHrefCollectionItemIdFrom.value = selectGetHrefCollectionItemIdFromValue;
        inputPathField.value = pathFieldName;
        inputPathSEO.value = pathSEOName;

        if (target === '_blank') {
          inputsPageNewTab.checked = true;
        }

        if (onClick === 'return openLinkInNewWindow(this)') {
          inputsPageNewWindow.checked = true;
        }

        pageTab.style.display = 'block';
        pageButton.classList.add('active');

        urlButton.classList.remove('active');
        phoneButton.classList.remove('active');
        emailButton.classList.remove('active');

        urlTab.style.display = 'none';
        phoneTab.style.display = 'none';
        emailTab.style.display = 'none';
      }
    },
  });
}

const handleNewTabAndWindowCheckbox = (elInput, event, attrs, target) => {
  let isNewTab = false;
  let isNewWindow = false;
  const inputsUrlNewTab = elInput.querySelector('.webconnect-link__url__newtab');
  const inputsPageNewTab = elInput.querySelector('.webconnect-link__page__newtab');
  const inputsUrlNewWindow = elInput.querySelector('.webconnect-link__url__newwindow');
  const inputsPageNewWindow = elInput.querySelector('.webconnect-link__page__newwindow');
  if (event && event.target) {
    if ([inputsUrlNewTab, inputsPageNewTab].includes(event.target)) {
      isNewTab = true;
    }
    if ([inputsUrlNewWindow, inputsPageNewWindow].includes(event.target)) {
      isNewWindow = true;
    }
  } else {
    const inputUrlNewTabValue = inputsUrlNewTab.checked;
    const inputPageNewTabValue = inputsPageNewTab.checked;
    const inputsUrlNewWindowValue = inputsUrlNewWindow.checked;
    const inputsPageNewWindowValue = inputsPageNewWindow.checked;
    isNewTab =
      inputUrlNewTabValue ||
      inputUrlNewTabValue === 'true' ||
      inputPageNewTabValue ||
      inputPageNewTabValue === 'true';
    isNewWindow =
      inputsUrlNewWindowValue ||
      inputsUrlNewWindowValue === 'true' ||
      inputsPageNewWindowValue ||
      inputsPageNewWindowValue === 'true';
  }
  if (isNewTab) {
    if (attrs['onclick']) delete attrs['onclick'];
    target = '_blank';
    inputsPageNewWindow.checked = false;
    inputsUrlNewWindow.checked = false;
  } else if (isNewWindow) {
    target = '';
    attrs['onclick'] = `return openLinkInNewWindow(this)`;
    inputsUrlNewTab.checked = false;
    inputsPageNewTab.checked = false;
  }
  return { attrs, target };
};
